import { useState } from 'react';
import { cn } from '../lib/cn';

// Shared fallback for products/models with no image. Tries a custom brand photo
// first (drop one at apps/frontend/public/product-placeholder.jpg — e.g. the
// Euroflex banner), then the bundled branded SVG, then a plain branded box.
const SOURCES = ['/product-placeholder.jpg', '/product-placeholder.svg'];

export function ProductPlaceholder({ className }: { className?: string }): JSX.Element {
  const [idx, setIdx] = useState(0);

  if (idx < SOURCES.length) {
    return (
      <img
        src={SOURCES[idx]}
        alt=""
        aria-hidden
        className={cn('w-full h-full object-cover', className)}
        onError={() => setIdx((i) => i + 1)}
      />
    );
  }
  return (
    <div
      className={cn(
        'w-full h-full flex flex-col items-center justify-center bg-paper-2 text-ink-4 select-none',
        className,
      )}
    >
      <span className="kc-serif text-2xl text-ink-3/40 leading-none">Kalachand</span>
      <span className="text-[9px] uppercase tracking-[0.3em] mt-1.5">No photo</span>
    </div>
  );
}
